<!--
 * @Description: 合并线索组件
 * @Author: mdb
 * @Date: 2022-07-13 17:35:13
 * @LastEditTime: 2023-03-12 14:23:28
 * @LastEditors: cxh
-->
<template>
  <CosModal
    v-model:visible="visible"
    :title="t('clue.clueMargeModalTitle')"
    width="800px"
    :bodyStyle="{ 'max-height': 'calc(100vh - 300px)', 'overflow-y': 'auto' }"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-alert :message="t('clue.clueMargeModalTips')" type="warning" show-icon />
    <ul class="list">
      <li v-for="(item, index) in optionsEnum" :key="index">
        <p>{{ t('clue.willCombination') }}：</p>
        <p class="name flex1" :title="item.label">{{ item.label }}</p>
        <div class="content" style="width: 230px">
          <p>ID：</p>
          <p class="name">{{ item.value }}</p>
        </div>
      </li>
    </ul>
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item :label="t('clue.afterCombination')" v-bind="validateInfos.targetClueId">
        <a-select v-model:value="dataForm.targetClueId" :placeholder="t('common.pleaseSelect')" allowClear>
          <a-select-option v-for="item in optionsEnum" :key="item.value" :value="item.value">{{
            `${item.label}(${item.value})`
          }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </CosModal>
</template>

<script setup lang="ts">
import { reactive, ref, computed } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueMarge } from '@/api/overseasSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ targetClueId: string; originalIdList: any[] }>({ targetClueId: '', originalIdList: [] })
const formRules = reactive({
  targetClueId: [{ required: true, message: t('clue.selectMainClue') }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const optionsEnum = computed(() => {
  return selectedData.value.map((item) => ({
    label: item.customerName,
    value: item.clueId
  }))
})
const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    const list = selectedData.value.filter((item) => item.clueId !== dataForm.targetClueId)
    dataForm.originalIdList = list.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueMarge(params)
      .then(() => {
        DcMessage.success(t('clue.clueMargeSussess'))
        resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ClueMarge' }
</script>

<style lang="scss" scoped>
.list {
  margin: 20px 0;

  li {
    display: flex;
    margin-bottom: 9px;
    justify-content: space-between;
    .content {
      display: flex;
      align-items: center;
    }
  }
  .name {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0;
    margin-right: 8px;
  }
}
.flex1 {
  flex: 1;
}
</style>
